import oopsImg from '@assets/img/illust/light/oops.svg';
import NoBorderWrapper from '@components/atoms/NoBorderWrapper';
import { useTheme } from '@hooks/useTheme';
import { getToken } from '@hooks/api';
import {
    ArrowRightIcon,
    BaseIcon,
    ButtonLabel,
} from '@moreharvest/component-library';
import { sendToSentry } from '@utils/sentry';
import { useEffect } from 'react';
import { Link, useRouteError } from 'react-router';

const Oops = () => {
    const error = useRouteError();
    useTheme();

    useEffect(() => {
        if (error) {
            sendToSentry('RouteError', 'React router error', {
                originalError: error,
                token: getToken(),
            });
        }
    }, [error]);

    return (
        <NoBorderWrapper>
            <img src={oopsImg} className="w-[358px]" />
            <div className="flex flex-col gap-y-7 items-center text-base-black dark:text-base-white">
                <h2 className="H2 font-semibold" data-cy="oops-title">
                    Oops
                </h2>
                <p className="Body-Large text-center">
                    Something went wrong. Please check and try again.
                </p>
            </div>
            <Link to="/" className="w-full mt-8">
                <ButtonLabel fullWidth size="medium" variant="solid">
                    <BaseIcon size="small">
                        <ArrowRightIcon className="fill-base-black rotate-180" />
                    </BaseIcon>
                    Back to Homepage
                </ButtonLabel>
            </Link>
        </NoBorderWrapper>
    );
};

export default Oops;
